// Toggle this to inject the simulation round instead of real spin data
export const DEV_SIMULATION_ENABLED = false;

export const DEV_SIMULATION_ROUND = {
  bet: 100,
  win: 50,
  wins: [
    {
      symbol: 12,
      win: 50,
      positions: [
        [0, 0],
        [1, 0],
      ],
      id: null,
      isScatter: true,
    },
  ],
  reels: [
    [12, 1, 1],
    [12, 8, 1],
    [1, 4, 1],
    [2, 7, 3],
    [8, 5, 1],
  ],
  type: "regular",
  id: `test-h1-wins-${Date.now()}`,
  winType: "epic_win",
  isAnimatedWin: false,
  scatterCount: 2,
  scatterPositions: [
    [0, 0],
    [1, 0],
  ],
};
